import React from "react";
import { HOW_STEPS } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">How it works</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            Your ride in three taps
          </h2>
          <p className="mt-4 text-white/60 text-lg">
            From door to destination, InstantDrive keeps it simple, transparent and fast.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {HOW_STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 120}>
                <div className="group relative h-full rounded-3xl border border-white/10 bg-[#0e1311] p-8 overflow-hidden transition-all duration-300 hover:border-[#2fd645]/40 hover:-translate-y-1">
                  <div className="absolute -top-10 -right-6 font-display font-black text-8xl text-white/[0.04] group-hover:text-[#2fd645]/10 transition-colors">
                    0{i + 1}
                  </div>
                  <div className="relative">
                    <div className="h-14 w-14 rounded-2xl bg-[#2fd645]/12 border border-[#2fd645]/25 flex items-center justify-center">
                      <Icon className="h-7 w-7 text-[#2fd645]" />
                    </div>
                    <h3 className="mt-6 text-xl font-bold text-white">{s.title}</h3>
                    <p className="mt-3 text-white/60 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
